import { ApiResponse } from '@/request/typings';
import { FaqQuestionBinds } from '@/types/faq';

export interface MetaSlice {
  togglePopupCartListVisible: (status: boolean) => void;
  currentActiveCartPosition: string;
  updateCurrentActiveCartPosition: (position?: string) => void;
  navCurStyle: {
    searchIcon: string;
  };
  isNavTextTransparent: boolean;
  navStateInfos: {
    is2024MTCSalePage: boolean;
    is2025TravelSalePage: boolean;
    isCampaignPage: boolean;
    isNavFixed: boolean;
    isHomePage: boolean;
    isHover: boolean;
    isMobileNavOpen: boolean;
    curState: ENavState;
  };
  /** 包邮门槛 */
  freeShippingAmount: {
    shippingCost: {
      currency: string;
      formatPrice: string;
      freeLimit: number;
    };
  };
  /** 获取其他类型的FAQ问答列表 */
  fetchOtherListQuestion: ({ type, pageKey }: FetchOtherListQuestionParams) => Promise<ApiResponse<FaqQuestionBinds>>;
  setStateValue: (key: string, value: unknown) => void;
}

/** fetchOtherListQuestion接口请求参数 */
type FetchOtherListQuestionParams = {
  type: 'page';
  pageKey: string;
};

/** 导航栏主题色 */
export enum ENavState {
  Default = 0,
  Dark = 1,
  Light = 2,
  DarkTransparentFull = 3, // 暗色透明
  LightTransparentFull = 4, // 亮色透明
}
